import Bowser from 'bowser' // ES6 (and TypeScript with --esModuleInterop enabled)

export function getWidthFromUserAgent(userAgent: string): number {
  let width = 1200
  try {
    if (!userAgent) {
      return width
    }
    const platformType = Bowser.parse(userAgent).platform.type || 'desktop'

    switch (platformType.toLowerCase()) {
      case 'desktop':
        width = 1200
        break
      case 'tablet':
        width = 990
        break
      case 'mobile':
      case 'phone':
        width = 400
        break
      default:
        width = 400
        break
    }
  } catch (e) {
    // some error, just return lap size
  }

  return width
}
